module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.3-211.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.1-rc.3.md
// module id = 654
// module chunks = 347